export const JOIN_GAME = 'JOIN_GAME';
export const LEAVE_GAME = 'LEAVE_GAME'

export function joinGame () {
  return {
    type: JOIN_GAME
  }
}

export function leaveGame () {
  return {
    type: LEAVE_GAME
  }
}